
import { Megaphone, Smartphone, Video } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

const Services = () => {
  const isMobile = useIsMobile();
  
  const services = [
    {
      icon: <Megaphone size={isMobile ? 32 : 42} className="mb-3 sm:mb-4 text-storystore-red" />,
      emoji: "📢",
      title: "Reklam & marknadsföring",
      description: "Kampanjer, annonser och strategier som sticker ut och ger resultat."
    },
    {
      icon: <Smartphone size={isMobile ? 32 : 42} className="mb-3 sm:mb-4 text-storystore-red" />,
      emoji: "📱",
      title: "Content & Sociala medier",
      description: "Innehåll som engagerar, bygger varumärke och fångar uppmärksamheten i flödet."
    },
    {
      icon: <Video size={isMobile ? 32 : 42} className="mb-3 sm:mb-4 text-storystore-red" />,
      emoji: "🎬",
      title: "Filmproduktion",
      description: "Reklamfilm, dokumentärt, intervjuer eller produktvideo – alltid med berättelsen i centrum."
    }
  ];

  return (
    <section id="tjanster" className="bg-white py-16 sm:py-24">
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-16 md:px-8 md:py-24">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-storystore-blue mb-3 sm:mb-4">Våra Tjänster</h2>
          <p className="text-base sm:text-xl text-gray-600 mb-8 sm:mb-12 max-w-3xl mx-auto">
            Vi hjälper dig att synas, höras och skapa resultat genom kreativa lösningar
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className={`bg-white p-6 sm:p-8 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 border-t-4 ${
                index === 1 
                  ? 'border-storystore-red bg-gradient-to-b from-white to-red-50 ring-2 ring-storystore-red ring-opacity-20 md:scale-105 relative' 
                  : 'border-storystore-red'
              }`}
            >
              {index === 1 && (
                <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                  <span className="bg-storystore-red text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide">
                    Vår Nisch
                  </span>
                </div>
              )}
              <div className="text-center">
                {service.icon}
                <span className="text-2xl sm:text-3xl">{service.emoji}</span>
                <h3 className={`text-xl sm:text-2xl font-bold mb-2 sm:mb-3 ${
                  index === 1 ? 'text-storystore-red' : 'text-storystore-blue'
                }`}>{service.title}</h3>
                <p className="text-sm sm:text-base text-gray-600">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 sm:mt-16 text-center">
          <a href="#kontakt" className="btn-primary text-sm sm:text-base py-2.5 px-4 sm:py-3 sm:px-6 inline-flex items-center gap-2">
            Kom igång med din nästa kampanj
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
